// Configuration for different environments
const config = {
  development: {
    API_BASE_URL: 'http://localhost:5000/api'
  },
  production: {
    // Use PHP API on the same server
    API_BASE_URL: '/api'
  }
};

// Get current environment
const env = process.env.NODE_ENV || 'development';

// Export configuration for current environment
export default config[env]; 